// based on rc-align 4.0.9
import Align from './Align';
export default Align;
